import { mapActions } from 'vuex';
import domainMixin from '../../../mixins/domain';

export default {
  mixins: [domainMixin],
  components: {},
  data() {
    return {
      hideForm: false,
      ruleForm: {
        email: '',
      },
      loading: false,
      rules: {
        email: [{ required: true, message: "Електрона пошта є обов'язковою" }],
      },
    };
  },
  methods: {
    ...mapActions(['forgotPassword']),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {     
          this.loading = true;    
          this.forgotPassword(this.ruleForm).then(() => {
            // this.$router.push('/');
            this.hideForm = true;
            this.loading = false;
          }).catch((error) => {            
            this.$notify.error({
              title: 'Error',
              message: error.response.data
            });
            this.loading = false;
          });
        } else {
          return false;
        }
      });
    },
  },
};
